import { Typography } from '@mui/material';
import useUpdateStatus from '../../../../api/useUpdateStatus';
import { useSnackbar } from '../../../../contexts/SnackBarContext';
import CustomModal from './CustomModal';
import AdminButton from '../AdminButton';

/**
 * Confirms an approve / reject, whichever card it came from — the pending card or the booking
 * details card. `onDecided` runs once the new status is saved, so the grid can show it, and also
 * when the booking turns out to be gone (DEC-0023) or decided already (DEC-0026), so the grid
 * shows it as it is now.
 */
const BookingDecisionModal = ({ show, handleClose, bookingId, actionType, onDecided = () => null }) => {
  const { updateStatus } = useUpdateStatus();
  const showSnackbar = useSnackbar();

  const title = actionType === 'APPROVE'
    ? 'Foglalás jóváhagyása'
    : 'Foglalás elutasítása';

  const handleConfirm = () => {
    if (actionType === 'APPROVE') {
      updateStatus(bookingId, 'BOOKED', () => {
        showSnackbar('A foglalás jóváhagyva', 'success');
        onDecided();
      }, onDecided);
    } else if (actionType === 'REJECT') {
      updateStatus(bookingId, 'REJECTED', () => {
        showSnackbar('A foglalás elutasítva', 'success');
        onDecided();
      }, onDecided);
    }
    handleClose();
  }

  return (
   <CustomModal
      open={show}
      onClose={handleClose}
      title={title}
    >
      <Typography variant="body2" align="center">
      {actionType === 'APPROVE' ?
       "Biztosan jóvá szeretnéd hagyni ezt a foglalást? A felhasználó emailben értesítést kap a döntésről." :
       "Biztosan el szeretnéd utasítani ezt a foglalást? A felhasználó emailben értesítést kap a döntésről."
      }
      </Typography>

      <AdminButton text="Megerősítés" onClick={handleConfirm} />
    </CustomModal>
  );
};

export default BookingDecisionModal;
